import { MModuleDetail } from './module-detail.model';
import { MSubversion } from './subversion.model';
import { Evaluation } from '../interfaces/Organization';

export class MEvaluation{
    public active: boolean;
    public id: number;
    public module: MModuleDetail;
    public subversion: MSubversion;
    public type: string;
    public version: string;

    constructor(eva: Evaluation){
        this.active = eva.activo;
        this.id = eva.id;
        this.module = new MModuleDetail(eva.modulo);
        this.subversion = new MSubversion(eva.subversion);
        this.type = eva.tipo;
        this.version = eva.version;
    }
}